import { DollarSign } from 'lucide-react';
import { FilterNumberConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionBudgetAmountFilterConfig(): FilterNumberConfig {
  return {
    label: 'Budget amount',
    icon: <DollarSign />,
    type: 'number',
    createDefaultValue: () => ({ operator: 'equal', value: 0 }),
    options: {}
  };
}
